import React, { Component } from "react";
import { fromJS } from "immutable";

import EditorMessage from "../../infra/components/EditorMessage";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import { ListHeaderCardFormat } from "../../store/local/list";

import ButtonManager from "./ButtonManager";
import "./Styles.css";

class CardCarouselInput extends Component {
  render() {
    const {
      categoryId,
      disabled,
      editorHtmlCarousels,
      index,
      errors,
      handleChange,
      onEditorChange,
      setParamSize,
      buttons,
      paramSize,
      rawMessage,
      format,
      onRemove,
      onAddMoreCard,
      handleOnFileChanged,
      handleUploadFile,
      handleCancelFile,
      fileKey,
      statButtonUpload,
      statDisableButton,
      fileNameExamp,
    } = this.props;

    return (
      <div className="input-card-carousel">
        <div className="row no-margin-bottom w-100">
          <div className="w-100 d-flex align-items-center">
          <p className="col-sm-12 font-weight-bold mb-2">Card {index + 1}</p>
            {onRemove && !disabled && (
              <button
                type="button"
                className="btn btn-danger btn-remove-card"
                onClick={() => onRemove(index)}
              >
                Remove
              </button>
            )}
          </div>
        </div>
        <div className="row no-margin-bottom">
          <div className="col-sm-12">
            <span className="col-12 pt-2 no-margin-bottom required">
              Card Header Format
            </span>
            <div className="col-12">
              <ComboboxInput
                field="format"
                value={format ? format.toLowerCase() : format}
                options={fromJS({
                  source: ListHeaderCardFormat(),
                  value: "value",
                  label: "label",
                })}
                onChange={(field, value) => handleChange(field, value, index)}
                placeholder="Select Header Format"
                disabled={disabled}
              />
            </div>
          </div>
          {index === 0 && (
            <>
              <div className={`col-sm-12 mb-0`}>
                <span className="col-sm-4">Example File</span>
                <div className="col-sm-7 mb-0">
                    <input className="form-control"
                        type="file"
                        name="file"
                        disabled={statDisableButton}
                        style={{ display: statButtonUpload }}
                        key={fileKey}
                        onClick={e => (e.target.value = null)}
                        onChange={handleOnFileChanged}
                    />
                    <p>{fileNameExamp}</p>
                </div>
              </div>
              <div className="col-sm-12">
                <button type="button"
                    className="btn btn-info mr-2"
                    disabled={statDisableButton}
                    onClick={handleUploadFile}>
                    Upload
                </button>
                <button type="button"
                    className="btn btn-danger"
                    disabled={!statDisableButton}
                    onClick={handleCancelFile}>
                    Change
                </button>
              </div>
            </>
          )}
          <p className="col-sm-12 no-margin-bottom">
            <span className="required">Raw Message</span>
          </p>
          <div className={`col-sm-12 pt-2`}>
            <div>
              <EditorMessage
                value={editorHtmlCarousels[index]}
                lengthValue={rawMessage ? rawMessage.length : 0}
                onChange={(value, content) =>
                  onEditorChange(value, content, index)
                }
                setParamSize={(paramSize, value) =>
                  setParamSize(paramSize, value, index)
                }
                paramSize={paramSize}
                disabled={disabled}
                placeholder={"Input message here..."}
                maxLength={160}
              />
              {onAddMoreCard && !disabled && (
                <button
                type="button"
                className="btn btn-primary btn-add-card"
                onClick={() => onAddMoreCard()}
              >
                Add more card
              </button>
              )}
            </div>
          </div>
          <ButtonManager
            required
            disabled={disabled}
            categoryId={categoryId}
            templateType="carousel"
            items={buttons}
            onChange={(field, value) => handleChange(field, value, index)}
            hasError={errors.has("template-carousels")}
          />
        </div>
      </div>
    );
  }
}

export default CardCarouselInput;
